import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../NavigationButton/index.js';
import { NavigationButton } from '../NavigationButton/NavigationButton.js';

var PrevButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(NavigationButton, _extends({}, props, {
    align: "start",
    ref: ref
  }));
});
PrevButton.displayName = 'PrevButton';

export { PrevButton };
//# sourceMappingURL=PrevButton.js.map
